<div mat-dialog-content>
  <div class="flex flex-col" *ngIf="physicalAddress.id > 0">
    <div class="flex flex-row">
      <button class="ml-auto" type="button" mat-button color="primary" (click)="exportPDF()">Export PDF</button>
    </div>
    <ng-container [ngTemplateOutlet]="licenseTemplate"
                  [ngTemplateOutletContext]="{export: false}"></ng-container>

    <button class="ml-auto" type="button" mat-button color="warn" (click)="close()">Close</button>
  </div>
</div>

<div class="print-outer" *ngIf="physicalAddress.id > 0">
  <div class="print-inner">
    <kendo-pdf-export #pdf paperSize="letter" [scale]="0.75" margin="1cm">
      <ng-container [ngTemplateOutlet]="licenseTemplate"
                    [ngTemplateOutletContext]="{export: true}"></ng-container>
    </kendo-pdf-export>
    </div>
</div>

<ng-template #licenseTemplate let-export="export">
  <div class="pdf-document flex flex-col gap-6">
    <span class="font-semibold text-blue-600">Dear Agency Administrator,</span>

    <div class="flex flex-col">
      <span class="font-semibold text-blue-600">As a reminder, please post your license in a prominent,
        visible location in your agency office, including any applicable branch office locations.</span>
    </div>

    <div class="flex flex-col">
      <span class="font-semibold text-blue-600">APD Medicaid providers, please fax a copy of your license to 503-947-5357</span>
      <span class="font-semibold text-blue-600">If you have any questions regarding your license please contact:</span>
    </div>

    <div class="flex flex-col">
      <span class="text-blue-600">* <a href="mailto:Mailbox.inhomecare@odhsoha.oregon.gov">Mailbox.inhomecare&#64;odhsoha.oregon.gov</a></span>
      <span class="text-blue-600">* 971-673-0540 (option 3)</span>
    </div>

    <div class="flex flex-col">
      <span class="text-blue-600">Thank you,</span>
      <span class="text-blue-600">In-Home Care Program Staff</span>
    </div>

    <div *ngIf="export" style="height: 250pt;"></div>

    <div class="flex flex-col border-8 px-5 py-2 border-blue-600">
      <div class="flex flex-col items-center">
        <span class="font-semibold text-blue-600">OREGON HEALTH AUTHORITY PUBLIC HEALTH DIVISION</span>
        <span class="font-semibold text-blue-600">HEALTH CARE FACILITY</span>
      </div>

      <div class="flex flex-row">
        <div class="flex flex-col">
          <span class="font-semibold text-black">{{license.licenseId}}</span>
          <span class="text-blue-600 border-t-2 border-blue-600">License Number</span>
        </div>
        <div class="flex flex-col ml-auto">
          <span class="font-semibold text-black">{{license.expirationDate | date:'longDate'}}</span>
          <span class="text-blue-600 border-t-2 border-blue-600">Expiration Date</span>
        </div>
      </div>

      <div class="flex flex-row justify-center">
        <div class="flex flex-col">
          <span class="font-semibold text-black">Class: IHC-{{license.classificationLevel}}</span>
          <span *ngFor="let city of branchCities" class="font-semibold text-black">Branch: {{city}}</span>

          <span class="font-semibold text-black mt-8">{{license.entityName}}</span>
          <span class="text-black">DBA {{license.agencyDBAName}}</span>
          <span class="text-black">{{physicalAddress.street}}</span>
          <span class="text-black">{{physicalAddress.city}}, {{physicalAddress.state}} {{physicalAddress.zip}}</span>
        </div>
      </div>

      <span class="font-semibold text-black">Issued: {{license.approvedDate | date}}</span>
    </div>
  </div>
  <div class="flex flex-row justify-center pt-2">
    <span class="text-blue-600 text-sm">MUST BE POSTED IN A CONSPICUOUS PLACE - NOT TRANSFERABLE</span>
  </div>
</ng-template>
